/* global window */
/* eslint-disable no-unused-vars */
import React, { Suspense, useEffect } from 'react';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import accessTokenAtom from '../recoil/user/accessTokenAtom';
import Unauthorized from './auth/Unauthorized';
import Loading from './general/Loading';
import AccessInfoSelector from '../recoil/selectors/AccessInfoSelector';
import subscriptionTypeAtom from '../recoil/user/subscriptionTypeAtom';

export default function AppWrapper({ children }) {
  const location = useLocation();

  const [accessToken, setAccessToken] = useRecoilState(accessTokenAtom);
  const setSubscriptionType = useSetRecoilState(subscriptionTypeAtom);
  const { network } = useRecoilValue(AccessInfoSelector);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const inputAccessToken = params.get('access_token');
    const inputType = params.get('type');

    let didUpdate = false;

    if (inputType) {
      setSubscriptionType(inputType);
      params.delete('type');
      didUpdate = true;
    }

    if (inputAccessToken) {
      setAccessToken(inputAccessToken);
      params.delete('access_token');
      didUpdate = true;
    } else if (window.accessToken) {
      setAccessToken(window.accessToken);
    }

    // Remove access_token and feature type from the URL but keep others
    if (didUpdate) {
      const path = window.location.pathname;
      const query = params.toString();
      const newUrl = query ? `${path}?${query}` : path;
      window.history.replaceState({}, '', newUrl);
    }
  }, [location.search]);

  if (!accessToken) {
    return <Unauthorized />;
  }

  const stylesheetPath = `/css/${network}.css`;

  return (
    <>
      <div>
        <link rel="stylesheet" href={stylesheetPath} />
      </div>
      <Suspense fallback={<Loading forceCenter />}>
        { children }
      </Suspense>
    </>
  );
}
AppWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};
